import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import columns from './RenewalTable/columns';
import EditRenewalModal from './EditRenewal/EditModal';

import Filters from './Table/Filters';

import { useContext } from '../Context';

export default function RenewalTable({ showChoosePlanModal, startCreate }) {
  const { state } = useContext();

  const [editItem, setEditItem] = useState(null);

  const startEdit = (row) => {
    setEditItem(row);
  };

  const [paymentMethod, setPaymentMethod] = useState(null);
  const [renewalMethod, setRenewalMethod] = useState(null);
  const [status, setStatus] = useState(null);

  const plans = (state.policy.attributes.plans
    ? state.policy.attributes.plans.filter(
      (item) => item.attributes.active,
    )
    : [])
    .filter((plan) => (paymentMethod === null || plan.attributes.payment_information_id === paymentMethod)
    && (renewalMethod === null || plan.attributes.renewal_method === renewalMethod)
    && (status === null || plan.attributes.status === status));

  return (
    <>
      <Filters
        setPaymentMethod={setPaymentMethod}
        setRenewalMethod={setRenewalMethod}
        setStatus={setStatus}
      />
      <div className="datatable-style">
        <DataTable
          title=""
          columns={columns(startEdit, startCreate, showChoosePlanModal)}
          data={plans}
          noDataComponent={<div className="mt20">No matching records found</div>}
          persistTableHead
          pagination
          paginationComponentOptions={{
            selectAllRowsItem: true,
            selectAllRowsItemText: 'All',
          }}
        />
        <EditRenewalModal row={editItem} onHide={() => setEditItem(null)} />
      </div>
    </>
  );
}
